<template>
  <div class="container">
    <hospital-list></hospital-list>
    <authority-hospital></authority-hospital>
    <second-level>
      <div class="title">
        <h3 class="chinese">常见问题</h3>
        <div class="inner">
          <h3 class="english">Common Problem</h3>
          <p class="line"></p>
        </div>
      </div>
    </second-level>
    <common-problem></common-problem>
  </div>
</template>

<script>
import SecondLevel from "../../SecondLevel";
import HospitalList from "./HospitalList";
import AuthorityHospital from "./AuthorityHospital";
import CommonProblem from "./CommonProblem";
export default {
  name: "Index",
  components: {
    SecondLevel,
    HospitalList,
    AuthorityHospital,
    CommonProblem
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  computed: {}
};
</script>

<style lang="scss" scoped>
.container {
  width: 75%;
  margin: 0 auto;
}
</style>
